import React, { Fragment } from "react";
import ImageSection from "./ImageSection";
import SectionHeader from "./SectionHeader";
import GetInTouchButton from "./GetInTouchButton";
import Section from "./Section";
import ContainerWide from "./ContainerWide";
import ButtonText from "./ButtonText";
import scrollTo from "gatsby-plugin-smoothscroll";

const ImageSectionsGroupCareer = ({ header, imageSections, centerMobile }) => {
    return (
        <>
            {header && (
                <SectionHeader
                    header={header}
                    className="image-section-group__header"
                />
            )}
            {imageSections?.map((imageSectionWrapper, i) => (
                <Fragment key={i}>
                    <ImageSection {...imageSectionWrapper} flipped={i % 2} centerMobile={centerMobile} noMaxHeight={i === 0} />
                </Fragment>
            ))}
        </>
    );
};

export default ImageSectionsGroupCareer;
